<template>
    <div class="esignCode" v-show="isShowQr">
      <div class="esignCodeData">
        <em class="el-icon-close detIcon" @click="isShowOpen()"></em>
        <div class="qrcodeBorder">
          <div id="qrcode" ref="qrCodeUrl"></div>
        </div>
        <p class="describe">扫描二维码手写签名</p>
      </div>
    </div>
  </template>
  
  <script>
  import QRCode from "qrcodejs2";
  import { getStore } from "@/utils/localStorage";

  import { faceServe } from "@/api/home";
  
  export default {
    name: "esignCode",
    data() {
      return {
        isShowQr: false,
        topIdText: "",
        changeData: "",
        esignCodeData: "",
        mobileData: "",
        studentId: '', 
        isTime: null, 
      };
    },
    mounted() {
      this.mobileData = JSON.parse(getStore("userInfo")).mobile;
      this.studentId = JSON.parse(getStore("userInfo")).student_id;
    },
    methods: {
      creatQrCode() {
        // 先清空
        this.esignCodeData = null;
        this.$refs.qrCodeUrl.innerHTML = "";
  
        const url = window.location.origin;
        const getData = getStore("token");
        const _ENTRANCETYPE = this.$store.state.permission._ENTRANCETYPE;
        const time = new Date().getTime();
        this.$store.commit('common/getTimeMutation', time)
        let tag = _ENTRANCETYPE + this.studentId + this.mobileData + time;
        const text = `${url}/#/esignH5?token=${getData}&_ENTRANCETYPE=${_ENTRANCETYPE}&tag=${tag}`;
        console.log(text);
        this.esignCodeData = new QRCode(this.$refs.qrCodeUrl, {
          text: text,
          width: 180,
          height: 180,
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: QRCode.CorrectLevel.H,
        });
      },
      async isShowOpen() {
        this.isShowQr = !this.isShowQr;
        const codeHtml = document.getElementById("qrcode");
        codeHtml.innerHTML = "";
        if (this.isShowQr) {
          this.creatQrCode();
        //   this.$emit("getUpdateImg", this.mobileData);
        this.getUpdateImg();
        } else {
        //   this.$emit("closeQr");
        this.closeQr();
        }
      },
      isHideOpen() {
        this.isShowQr = false;
        // this.$emit("closeQr");
        this.closeQr();
      },
      // 获取上次图片
        getUpdateImg() {
            // const mobileData = JSON.parse(getStore("userInfo")).mobile;
            // const studentId = JSON.parse(getStore("userInfo")).student_id;
            const mobileData = this.mobileData;
            const studentId = this.studentId;
            const _ENTRANCETYPE = this.$store.state.permission._ENTRANCETYPE;
            let time = this.$store.state.common.time;
            let tag = _ENTRANCETYPE + studentId + mobileData + time;
            this.isTime = setInterval(() => {
                const data = {tag: tag};
                faceServe.getStudent(data).then(({ result }) => {
                    if (result.url) {
                        this.$emit('getImgUrl', result.url);
                        this.isHideOpen();
                        this.closeQr();
                    }
                });
            }, 3000);
        },
        closeQr() {
            if (this.isTime) {
                clearInterval(this.isTime);
                this.isTime = null;
            }
        },
    },
  };
  </script>
  
  <style scoped lang="scss">
  .esignCode {
    width: 100%;
    height: 100%;
    position: fixed;
    background: rgba(0, 0, 0, 0.4);
    left: 0;
    top: 0;
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .esignCodeData {
    width: 300px;
    height: 300px;
    background: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
  }
  .qrcodeBorder {
    width: 200px;
    height: 200px;
    border: 1px solid #e8e8e8;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 40px;
  }
  .detIcon {
    position: absolute;
    top: 15px;
    right: 15px;
    font-size: 30px;
    cursor: pointer;
  }
  .describe {
    color: #333;
    font-size: 14px;
    margin-top: 30px;
  }
  </style>
  